// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39yzI","toggle":"styles_toggle__38uEe","preview":"styles_preview__ipvXt"};